import { render } from "./SelectUser.vue?vue&type=template&id=1b59aa36&scoped=true"
import script from "./SelectUser.vue?vue&type=script&lang=js"
export * from "./SelectUser.vue?vue&type=script&lang=js"

import "./SelectUser.vue?vue&type=style&index=0&id=1b59aa36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b59aa36"]])

export default __exports__